// // src/Demo.js
// import React, { useEffect, useState } from 'react';
// import * as pdfjsLib from 'pdfjs-dist/build/pdf';
// import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

// pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

// const Demo = ({ url }) => {
//   const [textContent, setTextContent] = useState('');

//   useEffect(() => {
//     const loadPdf = async () => {
//       try {
//         const loadingTask = pdfjsLib.getDocument(url);
//         const pdf = await loadingTask.promise;
//         const page = await pdf.getPage(1);
//         const content = await page.getTextContent();
//         const strings = content.items.map(item => item.str);
//         setTextContent(strings.join(' '));
//       } catch (err) {
//         console.error('Error loading PDF:', err);
//       }
//     };

//     loadPdf();
//   }, [url]);

//   return (
//     <div style={styles.container}>
//       <h2>PDF Text (Page 1)</h2>
//       <p style={styles.text}>{textContent}</p>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: '20px',
//     maxWidth: '800px',
//     margin: '0 auto',
//     fontFamily: 'Arial, sans-serif',
//     backgroundColor: '#f2f7ff',
//     borderRadius: '10px',
//   },
//   text: {
//     whiteSpace: 'pre-wrap',
//     lineHeight: '1.6',
//   },
// };

// export default Demo;

import React, { useEffect, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

const Demo = ({ url }) => {
  const [pages, setPages] = useState([]);
  const [iframeSrc, setIframeSrc] = useState(null);

  useEffect(() => {
    const loadPdf = async () => {
      try {
        const loadingTask = pdfjsLib.getDocument(url);
        const pdf = await loadingTask.promise;
        const numPages = pdf.numPages;

        const extractedPages = [];

        for (let pageNum = 1; pageNum <= numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const content = await page.getTextContent();
          const strings = content.items.map(item => item.str.trim()).filter(Boolean);
          const fullText = strings.join('\n');

          const lines = fullText.split('\n');
          const contentBlocks = [];

          let currentHeading = '';
          let currentParagraph = '';

          const isHeading = (line) => {
            return (
              line.length > 2 &&
              (line === line.toUpperCase() ||
                (/^[A-Z][a-z]+\s[A-Z]?[a-z]+/.test(line) && line.length < 50))
            );
          };

          const pushBlock = () => {
            if (currentHeading && currentParagraph) {
              contentBlocks.push({ heading: currentHeading.trim(), paragraph: currentParagraph.trim() });
              currentHeading = '';
              currentParagraph = '';
            }
          };

          for (let line of lines) {
            if (isHeading(line)) {
              pushBlock();
              currentHeading = line;
            } else {
              currentParagraph += ' ' + line;
            }
          }
          pushBlock(); // last block

          extractedPages.push({ page: pageNum, blocks: contentBlocks });
        }

        setPages(extractedPages);
      } catch (err) {
        console.error('Error loading PDF:', err);
      }
    };

    loadPdf();
  }, [url]);

  const handleHeadingClick = (pageNum) => {
    const pdfWithPage = `${url}#page=${pageNum}`;
    setIframeSrc(pdfWithPage); // ✅ Show inside iframe
  };

  return (
    <div style={styles.container}>
      {pages.map(({ page, blocks }) => (
        <div key={page} style={styles.pageSection}>
          <h3 style={styles.pageLabel}>Page {page}</h3>
          {blocks.map((block, idx) => (
            <div key={idx} style={{ marginBottom: '25px' }}>
              <h4
                style={{ ...styles.heading, cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => handleHeadingClick(page)}
              >
                {block.heading}
              </h4>
              <p style={styles.paragraph}>{block.paragraph}</p>
            </div>
          ))}
        </div>
      ))}

      {iframeSrc && (
        <div style={styles.iframeContainer}>
          <h3>PDF Preview</h3>
          <iframe
            title="PDF Viewer"
            src={iframeSrc}
            width="100%"
            height="600px"
            style={{ border: '1px solid #ccc' }}
          ></iframe>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    maxWidth: '1000px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f0f8ff',
    borderRadius: '10px',
  },
  pageSection: {
    marginBottom: '40px',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  },
  pageLabel: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#888',
    marginBottom: '10px',
  },
  heading: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#003366',
    marginBottom: '8px',
  },
  paragraph: {
    fontSize: '16px',
    lineHeight: '1.6',
    textAlign: 'justify',
  },
  iframeContainer: {
    marginTop: '40px',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 0 8px rgba(0,0,0,0.1)',
  },
};

export default Demo;





